export const RACHEL_CONVERSATION_MAX_WIDTH = 640;

export const RACHEL_ASK_USER_TOOL_NAME = 'perguntar_ao_usuario' as const;
export const RACHEL_ASK_USER_PART_TYPE = `tool-${RACHEL_ASK_USER_TOOL_NAME}` as const;
export const RACHEL_ASK_USER_SKIPPED_ANSWER = 'usuário pulou a pergunta';
